function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xb8d8ef;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;

    var itemsPositionsObject = { b_0_8: { x: 1018, y: 460, w: 97, h: 97, n: "b_0_8" }, b_0_7: { x: 902, y: 460, w: 97, h: 97, n: "b_0_7" }, b_0_6: { x: 790, y: 460, w: 97, h: 97, n: "b_0_6" }, b_0_5: { x: 1015, y: 268, w: 97, h: 97, n: "b_0_5" }, b_0_4: { x: 901, y: 268, w: 97, h: 97, n: "b_0_4" }, b_0_3: { x: 790, y: 268, w: 97, h: 97, n: "b_0_3" }, b_0_2: { x: 1018, y: 67, w: 97, h: 97, n: "b_0_2" }, b_0_1: { x: 904, y: 66, w: 97, h: 97, n: "b_0_1" }, b_0_0: { x: 790, y: 66, w: 97, h: 97, n: "b_0_0" }, l_0_0: { x: 337, y: 24, w: 775, h: 172, n: "l_0_0" }, l_0_1: { x: 367, y: 226, w: 747, h: 145, n: "l_0_1" }, l_0_2: { x: 330, y: 389, w: 782, h: 169, n: "l_0_2" }, b_1_8: { x: 1017, y: 461, w: 97, h: 97, n: "b_1_8" }, b_1_7: { x: 902, y: 461, w: 97, h: 97, n: "b_1_7" }, b_1_6: { x: 790, y: 461, w: 97, h: 97, n: "b_1_6" }, b_1_5: { x: 1016, y: 268, w: 97, h: 97, n: "b_1_5" }, b_1_4: { x: 902, y: 268, w: 97, h: 97, n: "b_1_4" }, b_1_3: { x: 790, y: 268, w: 97, h: 97, n: "b_1_3" }, b_1_2: { x: 1016, y: 65, w: 97, h: 97, n: "b_1_2" }, b_1_1: { x: 903, y: 66, w: 97, h: 97, n: "b_1_1" }, b_1_0: { x: 790, y: 65, w: 97, h: 97, n: "b_1_0" }, l_1_0: { x: 328, y: 19, w: 790, h: 155, n: "l_1_0" }, l_1_1: { x: 332, y: 222, w: 783, h: 163, n: "l_1_1" }, l_1_2: { x: 332, y: 419, w: 784, h: 143, n: "l_1_2" }, b_2_8: { x: 968, y: 462, w: 97, h: 97, n: "b_2_8" }, b_2_7: { x: 850, y: 461, w: 97, h: 97, n: "b_2_7" }, b_2_6: { x: 732, y: 463, w: 97, h: 97, n: "b_2_6" }, b_2_5: { x: 967, y: 267, w: 97, h: 97, n: "b_2_5" }, b_2_4: { x: 850, y: 267, w: 97, h: 97, n: "b_2_4" }, b_2_3: { x: 732, y: 266, w: 97, h: 97, n: "b_2_3" }, b_2_2: { x: 967, y: 65, w: 97, h: 97, n: "b_2_2" }, b_2_1: { x: 850, y: 65, w: 97, h: 97, n: "b_2_1" }, b_2_0: { x: 732, y: 64, w: 97, h: 97, n: "b_2_0" }, l_2_0: { x: 376, y: 26, w: 686, h: 149, n: "l_2_0" }, l_2_1: { x: 383, y: 232, w: 681, h: 139, n: "l_2_1" }, l_2_2: { x: 361, y: 386, w: 704, h: 178, n: "l_2_2" } };

    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);
        document.addEventListener('stopGame', onStopGame, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function onStopGame() {
        end();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 1600);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 3;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(0, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('gioco', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        // if (gameData.numItems > 1) {
        game.gameContainer.addChild(counter.container);
        //  }

    }


    function positionGameItems() {
        sprites.btn_gioca.x = 937;
        sprites.btn_gioca.y = 422;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        //  gameData.currentItem++;
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;
    var levels = {};

    levels.level_0 = {
        buttons: [
            [false, false, true],
            [false, true, false],
            [true, false, false]
        ],
        answers: [],
        container: new Container()
    };

    levels.level_1 = {
        buttons: [
            [false, true, true],
            [true, false, true],
            [false, true, true]
        ],
        answers: [],
        container: new Container()
    };

    levels.level_2 = {
        buttons: [
            [true, false, false],
            [false, true, false],
            [false, false, true]
        ],
        answers: [],
        container: new Container()
    };



    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer;


    var gameIndex = 0;
    var sceneElements = {};
    var levelNames = ['0', '1', '2'];

    var currentLevelData;
    var currentLevelContainer;
    var currentLevelName;




    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);


    initScene();

    function initScene() {
        var i, ii, iii;

        var spriteItem;
        var pos;


        for (i = 0; i < 3; i++) {
            currentLevelName = levelNames[i];
            currentLevelData = levels['level_' + currentLevelName];
            currentLevelContainer = currentLevelData.container;
            container.addChild(currentLevelContainer);
            buttonsContainer = new Container();
            sceneElements['buttonsContainer_' + currentLevelName] = buttonsContainer;

            buttonsContainer.interactive = true;
            // spriteItem.buttonMode = true;
            buttonsContainer.on('pointertap', onClick);



            for (ii = 0; ii < currentLevelData.buttons.length; ii++) {
                pos = positions['l_' + currentLevelName + '_' + ii];
                spriteItem = game.sprites['l_' + currentLevelName + '_' + ii];
                spriteItem.position.set(pos.x, pos.y);
                currentLevelContainer.addChild(spriteItem);
                sceneElements['l_' + currentLevelName + '_' + ii] = spriteItem;
                for (iii = 0; iii < currentLevelData.buttons[ii].length; iii++) {
                    pos = positions['b_' + currentLevelName + '_' + (ii * 3 + iii)];
                    spriteItem = new Graphics();
                    spriteItem.position.set(pos.x, pos.y);
                    spriteItem.name = ii * 3 + iii;

                    spriteItem.beginFill(0xd6bad3);
                    spriteItem.lineStyle(0, 0x000000);
                    spriteItem.drawRect(0, 0, pos.w, pos.h);
                    spriteItem.endFill();
                    spriteItem.interactive = true;
                    spriteItem.buttonMode = true;
                    spriteItem.alpha = 0;
                    buttonsContainer.addChild(spriteItem);
                    sceneElements['b_' + currentLevelName + '_' + (ii * 3 + iii)] = spriteItem;

                    if (currentLevelData.buttons[ii][iii]) {
                        spriteItem = new Sprite(game.sprites.cerchio_bianco.texture);
                    } else {
                        spriteItem = new Sprite(game.sprites.X_bianca.texture);
                    }

                    var delta = (95 - spriteItem.width) / 2;
                    spriteItem.position.set(pos.x + delta, pos.y + delta);
                    currentLevelContainer.addChild(spriteItem);
                    sceneElements['answer_' + currentLevelName + '_' + (ii * 3 + iii)] = spriteItem;

                }


                currentLevelContainer.alpha = 0;
                currentLevelContainer.addChild(buttonsContainer);

            }
        }

    }


    function clear() {


    }

    function reset() {
        // levelNames = _.shuffle(levelNames);
        gameIndex = 0;
        setState('newLevel');
    }

    function resetLevels() {
        var i, ii, iii;

        for (i = 0; i < levelNames.length; i++) {
            currentLevelName = levelNames[i];
            currentLevelData = levels['level_' + currentLevelName];
            currentLevelContainer = currentLevelData.container;
            currentLevelContainer.alpha = 0;
            currentLevelData.answers = [];
            sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = false;
            sceneElements['buttonsContainer_' + currentLevelName].interactive = false;
            for (ii = 0; ii < currentLevelData.buttons.length; ii++) {
                var answer = [];
                currentLevelData.answers.push(answer);
                for (iii = 0; iii < currentLevelData.buttons[ii].length; iii++) {
                    sceneElements['b_' + currentLevelName + '_' + (ii * 3 + iii)].interactive = true;
                    sceneElements['answer_' + currentLevelName + '_' + (ii * 3 + iii)].alpha = 0;
                    answer.push(false);
                }
            }
        }
        answers = [];
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newLevel':
                resetLevels();


                levelNames.push(levelNames.shift());

                currentLevelName = levelNames[0];
                currentLevelData = levels['level_' + currentLevelName];
                sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = true;
                sceneElements['buttonsContainer_' + currentLevelName].interactive = true;
                currentLevelContainer = currentLevelData.container;
                currentLevelContainer.interaciveCildren = true;
                currentLevelContainer.alpha = 1;

                break;
            case 'ready':
                loopSequence = [renderOnce];
                break;
            case 'animating':


                break;
        }
        currentState = state;

    }




    function onClick(e) {

        if (currentState === "ready") {


            var clicked = e.target.name;
            var line = Math.floor(clicked / 3);
            var index = clicked % 3;
            var ok = currentLevelData.buttons[line][index];

            sceneElements['answer_' + currentLevelName + '_' + clicked].alpha = 1;
            sceneElements['b_' + currentLevelName + '_' + clicked].interactive = false;
            loopSequence = [renderOnce];
            if (ok) {

                currentLevelData.answers[line][index] = true;
                var lineOk = JSON.stringify(currentLevelData.answers[line]) === JSON.stringify(currentLevelData.buttons[line]);
                if (lineOk) {
                    var levelFinished = JSON.stringify(currentLevelData.answers) === JSON.stringify(currentLevelData.buttons);

                    //   if (levelFinished) {
                    //      console.log('levelFinished')
                    //       renderer.view.dispatchEvent(new Event('answerOk'));
                    //       setTimeout(okFinished, 3000);
                    //    } else {

                    renderer.view.dispatchEvent(new Event('answerOk'));
                    setTimeout(okComplete, 800);
                    //  }
                }



            } else {


                renderer.view.dispatchEvent(new Event('answerWrong'));
                setTimeout(wrongComplete, 1600);
                setState('animating');


            }
        }

    }



    function okComplete() {

        theGame.cycleGame();


    }

    function okFinished() {
        //  gameIndex++;
        // if (gameIndex < 3) {
        //      setState('newLevel');
        //   }
        theGame.cycleGame();



    }

    function wrongComplete() {

        theGame.cycleGame();

    }
}